import { React, useState, useEffect } from 'react';
import PageHeader from 'utility/PageHeader';
import PageBody from 'utility/PageBody';
import { Button, Form, Input, Row, Col, Table, Modal, Image, Select, Upload, Skeleton, Spin, DatePicker, Radio, Checkbox, Statistic } from 'antd';
import { HttpHandler } from '../../shared/httpHandler';
import { EditOutlined, DeleteOutlined, RocketOutlined, PlusOutlined, SearchOutlined, UploadOutlined } from '@ant-design/icons';
import moment from 'moment';
import dayjs from 'dayjs';

const httpHandler = new HttpHandler();

const { Option } = Select;

const fakeMemberData = [
    {
        member_name: 'John Doe',
        line_uid: '1234567890',
        one_id: '0987654321',
        phone_number: '0912345678',
        gender: 'male',
        source: 'web',
        join_time: '2023-10-01',
        tag: 'VIP',
    },
    {
        member_name: 'Jane Smith',
        line_uid: '0987654321',
        one_id: '1234567890',
        phone_number: '0987654321',
        gender: 'female',
        source: 'app',
        join_time: '2023-10-02',
        tag: 'Regular',
    }
]

const MemberTagSearch = () => {
    const [memberTagSearchForm] = Form.useForm();
    const [assignNewTagForm] = Form.useForm();
    const [memberTagTableData, setMemberTagTableData] = useState([]);
    const [memberTagTableParams, setMemberTagTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const handleTableChange = (pagination, filters, sorter) => {
        setMemberTagTableParams({
            pagination,
            filters,
            ...sorter,
        });
        getMemberTag(pagination);
    };
    const [loading, setLoading] = useState(false);
    const [selectedTags, setSelectedTags] = useState([]);
    const [tagsList, setTagsList] = useState([]); // 用於存儲所有標籤
    const [fileList, setFileList] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);

    const searchMemberTagData = async () => {
        setMemberTagTableParams({
            ...memberTagTableData,
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
        getMemberTag({
            current: 1,
            pageSize: 10,
        });
        console.log('searchMemberTagData:', memberTagSearchForm.getFieldsValue());
    }

    const getMemberTag = async (pagination = memberTagTableParams.pagination) => {
        let { oneID, phoneNum, email, status, tag, joinTime, timeliness } = memberTagSearchForm.getFieldsValue();
        let lineUID = '';
        oneID = oneID ? oneID : '';
        phoneNum = phoneNum ? phoneNum : '';
        email = email ? email : '';
        status = status ? status : '';
        tag = tag ? tag : '';
        joinTime = joinTime ? dayjs(joinTime).format('YYYY-MM-DD HH:mm:ss') : '';
        // source = source ? source : '';
        // gender = gender ? gender : '';
        // birthday = birthday ? dayjs(birthday).format('YYYY-MM-DD') : '';
        timeliness = timeliness ? timeliness : '';

        const { current, pageSize } = pagination;
        // console.log('sendingTime:', sendingTime);

        setLoading(true);
        httpHandler.get(`/tag_maintenance/get_tag_data?line_id=${lineUID}&one_id=${oneID}&phone_number=${phoneNum}&email=${email}&tags=${tag}&create_time=${joinTime}&tag_timeliness=${timeliness}&tag_status=${status}&current=${current}&page_size=${pageSize}&brand=toyota`)
            .then((response) => {
                if (response.success) {
                    setMemberTagTableData(response.data);
                    setMemberTagTableParams({
                        ...memberTagTableData,
                        pagination: {
                            ...pagination,
                            total: response.total,
                        },
                    });
                } else {
                    window.antdNotify('錯誤', response.data.message, 'fail');
                }
                setLoading(false);
            });
        // setMemberTagTableData(fakeMemberData);
    }

    const getTagsList = async () => {
        setLoading(true);
        httpHandler.get(`/tag_maintenance/get_tags_list?brand=toyota`)
            .then((response) => {
                if (response.success) {
                    setTagsList(response.data);
                } else {
                    window.antdNotify('錯誤', response.data.message, 'fail');
                }
                setLoading(false);
            });
    }

    const MemberTagSearchBar = () => {
        return (
            <Form form={memberTagSearchForm}
                name="memberTagSearchForm"
                onFinish={searchMemberTagData}
                initialValues={{
                    timeliness: "30",
                    status: "",
                }}
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="手機號碼" name="phoneNum">
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="電子信箱" name="email">
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>

                    <Col span={8}>
                        <Form.Item label="標籤狀態" name="status">
                            <Select placeholder="請選擇狀態">
                                <Option value="">啟用</Option>
                                <Option value="D">停用</Option>
                                <Option value="Y">全部</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="加入時間" name="joinTime">
                            <DatePicker showTime allowClear />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item label="ONE ID" name="oneID" valuePropName="checked">
                            <Checkbox></Checkbox>
                        </Form.Item>
                    </Col>

                </Row>
                <Row gutter={16}>
                    {/* <Col span={6}>
                        <Form.Item label="標籤篩選">
                            <Radio.Group onChange={handleFilterModeChange} value={filterMode}>
                                <Radio value="OR">OR</Radio>
                                <Radio value="AND">AND</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col> */}
                    <Col span={6}>
                        <Form.Item label="標籤時效" name="timeliness">
                            <Select placeholder="請選擇標籤時效">
                                <Option value="30">30天內</Option>
                                <Option value="60">60天內</Option>
                                <Option value="90">90天內</Option>
                                <Option value="all">不限時間</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={18}>
                        <Form.Item label="標籤" name="tag">
                            <Select
                                mode="multiple" // 啟用多選模式
                                style={{ width: '100%' }}
                                placeholder="請選擇標籤，可多選最多五個標籤"
                                value={selectedTags} // 綁定選擇的標籤
                                onChange={(value) => {
                                    // 限制最多選擇五個
                                    if (value.length <= 5) {
                                        handleTagChange(value);
                                    } else {
                                        Modal.warning({
                                            title: '提示',
                                            content: '最多只能選擇五個標籤！',
                                        });
                                        // 如果超過五個，則不更新狀態
                                        return;
                                    }
                                }}
                                maxTagCount={5}
                                showSearch // 啟用模糊搜尋
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().includes(input.toLowerCase()) // 根據 TAGNM 進行模糊匹配
                                }
                            >
                                {/* 定義標籤選項 */}
                                {/* <Option value="標籤1">標籤1</Option>
                                <Option value="標籤2">標籤2</Option>
                                <Option value="標籤3">標籤3</Option>
                                <Option value="標籤4">標籤4</Option> */}
                                {tagsList.map(tag => (
                                    <Option key={tag.TAGID} value={tag.TAGID}>
                                        {tag.TAGNM}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                </Row>
                <Row gutter={16}>
                    <Col span={16} className="button-group">
                        <Button
                            type="primary"
                            onClick={() => {
                                setIsModalVisible(true);
                            }}
                            icon={<PlusOutlined />}
                            style={{ marginRight: '8px' }}>
                            新增標籤
                        </Button>
                        <Button
                            type="primary"
                            onClick={handleDownloadExample}
                            style={{ marginRight: '8px' }}>
                            匯入範例檔下載
                        </Button>
                        <Upload
                            name="excelFile"
                            accept=".xlsx,.xls" // 限制只接受 Excel 檔案
                            fileList={fileList}
                            beforeUpload={beforeUpload} // 檢查檔案類型
                            onChange={handleUploadChange} // 處理檔案上傳變更
                            onRemove={handleRemove} // 移除檔案
                        >
                            <Button style={{ marginRight: '8px' }} icon={<UploadOutlined />}>上傳 Excel</Button>
                        </Upload>
                        <Button
                            type="primary"
                            onClick={handleSendData}>
                            匯出資料
                        </Button>
                        <Button
                            type="primary"
                            icon={<SearchOutlined />}
                            htmlType="submit"
                            className="button button--search">
                            搜尋
                        </Button>
                    </Col>
                </Row>
            </Form >
        )
    }

    // 處理標籤選擇變更
    const handleTagChange = (tags) => {
        setSelectedTags(tags);
        // applyFilter(tags, filterMode); // 更新篩選結果
    };

    // // 處理篩選模式變更
    // const handleFilterModeChange = (e) => {
    //     const mode = e.target.value;
    //     setFilterMode(mode);
    //     applyFilter(selectedTags, mode); // 更新篩選結果
    // };
    // // 篩選邏輯
    // const applyFilter = (tags, mode) => {
    //     if (mode === 'OR') {
    //         console.log(`使用 OR 模式篩選，選擇的標籤: ${tags}`);
    //         // OR 篩選邏輯
    //         // 例如：篩選符合任一標籤的項目
    //     } else if (mode === 'AND') {
    //         console.log(`使用 AND 模式篩選，選擇的標籤: ${tags}`);
    //         // AND 篩選邏輯
    //         // 例如：篩選符合所有標籤的項目
    //     }
    // };

    const beforeUpload = (file) => {
        const isExcel =
            file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
            file.type === 'application/vnd.ms-excel';
        if (!isExcel) {
            prompt('只能上傳 Excel 檔案 (.xlsx, .xls)');
        }
        return isExcel || Upload.LIST_IGNORE; // 阻止非 Excel 檔案上傳
    };

    const handleRemove = (file) => {
        setFileList((prevFileList) => prevFileList.filter((f) => f.uid !== file.uid));
    };

    // 處理上傳貼標上傳 excel 檔案
    const handleUploadChange = ({ fileList }) => {
        console.log('handleUploadChange:', fileList);
        // 取出最新的檔案
        const latestFile = fileList[fileList.length - 1];

        if (latestFile) {
            // 檢查檔案類型是否為 Excel
            const isExcel =
                latestFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                latestFile.type === 'application/vnd.ms-excel';

            if (!isExcel) {
                console.error('只能上傳 Excel 檔案 (.xlsx, .xls)');
                return;
            }

            // 將檔案轉換為 Base64
            const reader = new FileReader();
            reader.onload = () => {
                const base64Data = reader.result.split(',')[1]; // 去掉 Base64 前綴
                const file = {
                    fileName: latestFile.name,
                    fileType: latestFile.type,
                    fileContent: base64Data,
                    brand: 'toyota',
                };

                // 發送 Base64 檔案到後端
                httpHandler.post('/tag_maintenance/upload_tag_excel', file)
                    .then((response) => {
                        if (response.success) {
                            console.log('上傳成功:', response.message);
                            Modal.success({
                                title: '上傳成功',
                                content: response.message,
                            });
                        } else {
                            console.error('上傳失敗:', response.message);
                            Modal.error({
                                title: '上傳失敗',
                                content: response.message,
                            });
                        }
                    })
                    .catch((error) => {
                        console.error('上傳失敗:', error);
                    });
            };

            reader.onerror = (error) => {
                console.error('檔案轉換失敗:', error);
            };

            reader.readAsDataURL(latestFile.originFileObj); // 讀取檔案並轉換為 Base64

            // // 使用 FormData 準備檔案上傳
            // const formData = new FormData();
            // formData.append('file', latestFile.originFileObj); // `originFileObj` 是原始檔案

            // // 發送檔案到後端
            // httpHandler.post('/tag_maintenance/upload_tag_excel', formData, 'multipart/form-data',)
            //     .then((response) => {
            //         if (response.success) {
            //             console.log('上傳成功:', response.message);
            //             Modal.success({
            //                 title: '上傳成功',
            //                 content: response.message,
            //             });
            //         } else {
            //             console.error('上傳失敗:', response.message);
            //             Modal.error({
            //                 title: '上傳失敗',
            //                 content: response.message,
            //             });
            //         }
            //     })
            //     .catch((error) => {
            //         console.error('上傳失敗:', error);
            //     });
        }
    }

    const transformTableData = (tableData) => {
        return {
            data: tableData.map(item => ({
                line_id: item.line_id || "string",
                one_id: item.one_id || "string",
                phone_number: item.phone_number || "string",
                email: item.email || "string",
                create_time: item.create_time || "string",
                tag_status: item.tag_status === '' ? '有效' : item.tag_status === 'N' ? '失效' : '未知',
                tag_id: item.tag_id || "string",
                tag_name: item.tag_name || "string"
            }))
        };
    };
    const handleSendData = () => {
        console.log('tableData:', memberTagTableData);
        if (memberTagTableData.length === 0) {
            Modal.warning({
                title: '提示',
                content: '尚無資料可下載，請先搜尋標籤資料！',
            });
            return;
        }
        // const postData = transformTableData(memberTagTableData);
        // console.log('postData:', postData);
        let { oneID, phoneNum, email, status, tag, joinTime, timeliness } = memberTagSearchForm.getFieldsValue();
        let lineUID = '';
        oneID = oneID ? oneID : '';
        phoneNum = phoneNum ? phoneNum : '';
        email = email ? email : '';
        status = status ? status : '';
        tag = tag ? tag : '';
        joinTime = joinTime ? dayjs(joinTime).format('YYYY-MM-DD HH:mm:ss') : '';
        timeliness = timeliness ? timeliness : '';
        Modal.confirm({
            title: '下載檔案',
            content: '是否下載標籤資料？',
            okText: '下載',
            cancelText: '取消',
            onOk: () => {
                httpHandler.get(`/tag_maintenance/set_tag_excel_download?line_id=${lineUID}&one_id=${oneID}&phone_number=${phoneNum}&email=${email}&tags=${tag}&create_time=${joinTime}&tag_timeliness=${timeliness}&tag_status=${status}&current=1&page_size=10&is_all=1&brand=toyota`)
                    .then((response) => {
                        if (response.success) {
                            console.log('下載檔名:', response.data);
                            const downloadLink = `${process.env.REACT_APP_BASE_URL}/dashboard/tag_maintenance/download_tag_excel_download?file_name=${response.data}`;
                            window.open(downloadLink, '_blank');
                        }
                    })
                    .catch((error) => {
                        console.error('下載失敗:', error);
                    });

            },
            onCancel: () => {
                console.log('取消下載');
            }
        });


    };

    const handleDownloadExample = () => {
        const downloadLink = `${process.env.REACT_APP_BASE_URL}/dashboard/tag_maintenance/download_tag_excel_download?file_name=tag_assign_example.xlsx`;
        window.open(downloadLink, '_blank');
    }


    const MemberTagDataTable = () => {
        const columns = [
            {
                title: 'LINE UID',
                dataIndex: 'line_id',
                key: 'line_id',
            },
            {
                title: 'ONE ID',
                dataIndex: 'one_id',
                key: 'one_id',
            },
            {
                title: '手機號碼',
                dataIndex: 'phone_number',
                key: 'phone_number',
            },
            {
                title: '電子信箱',
                dataIndex: 'email',
                key: 'email',
            },
            {
                title: '建立時間',
                dataIndex: 'create_time',
                key: 'create_time',
            },
            {
                title: '標籤名稱',
                dataIndex: 'tag_name',
                key: 'tag_name',
            },
            {
                title: '標籤 ID',
                dataIndex: 'tag_id',
                key: 'tag_id',
            },
            {
                title: '標籤狀態',
                dataIndex: 'tag_status',
                key: 'tag_status',
                render: (text) => {
                    return text === '' ? '有效' : text === 'N' ? '失效' : '未知';
                }
            },

        ]

        return (
            <div>
                <Row justify="end" style={{ padding: '0 16px', marginBottom: '4px' }}>
                    <Col>
                        <Statistic
                            value={memberTagTableData.length}
                            prefix={<>
                                <SearchOutlined style={{ fontSize: '20px', fontWeight: 900, color: '#696969' }} />
                                <span style={{ fontSize: '20px', marginRight: '4px', fontWeight: 900, color: '#696969' }}>Total:</span>
                            </>}
                            valueStyle={{ fontSize: '16px', fontWeight: 700, color: '#3C3C3C' }}
                            formatter={value => `${value.toLocaleString()} 筆`}
                        />
                    </Col>
                </Row>
                <Table columns={columns} loading={loading} dataSource={memberTagTableData} pagination={memberTagTableParams.pagination} scroll={{ x: 'max-content' }} onChange={handleTableChange} />
            </div>
        );
    }

    const AssignNewTagModal = () => {

        const editModalSubmitHandler = () => {
            const formData = assignNewTagForm.getFieldsValue();
            console.log('formData:', formData);
            const postData = {
                "brand": "toyota",
                "tag_id": formData.tagID,
                "tag_name": formData.tagName,
                "tag_note": formData.tagNote || '',
                "tag_source": formData.tagSource || '',
                "tag_status": formData.tagStatus === 'Y' ? '' : formData.tagStatus === 'N' ? 'D' : formData.tagStatus,
            };
            console.log('postData:', postData);
            httpHandler.post('/tag_maintenance/assign_new_tag?brand=toyota', postData)
                .then((response) => {
                    if (response.success) {
                        window.antdNotify('成功', '新增標籤成功', 'success');
                        assignNewTagForm.resetFields(); // 重置表單
                        getTagsList(); // 重新獲取標籤列表
                    } else {
                        window.antdNotify('錯誤', response.data.message, 'fail');
                    }
                })
                .catch((error) => {
                    console.error('新增標籤失敗:', error);
                });
        }

        const showConfirm = () => {
            const submitData = assignNewTagForm.validateFields()
                .then((values) => {
                    Modal.confirm({
                        title: `確認`,
                        content: `確定要新增標籤嗎？`,
                        okText: '確定',
                        cancelText: '取消',
                        onOk() {
                            editModalSubmitHandler();
                            setIsModalVisible(false);
                        },
                        onCancel() {
                            console.log('取消新增');
                        },
                    });
                })
                .catch((errorInfo) => {
                    console.log('Validation failed:', errorInfo);
                    return null;
                });
            // console.log('submitData:', submitData);

        };

        const handleModalOnCancel = () => {
            assignNewTagForm.resetFields();
            setIsModalVisible(false);
        }

        return (
            <Modal
                title="新增標籤"
                visible={isModalVisible}
                onOk={showConfirm}
                onCancel={() => setIsModalVisible(false)}
                width={800}
                footer={[
                    <Button
                        key="close"
                        onClick={() => {
                            handleModalOnCancel();
                        }}
                    >
                        關閉
                    </Button>,
                    <Button
                        key="save"
                        type="primary"
                        onClick={() => {
                            showConfirm();
                        }}
                    >
                        新增
                    </Button>,
                ]}
            >
                <Form
                    form={assignNewTagForm}
                    name='assignNewTagForm'
                >
                    <Form.Item
                        label="標籤 ID"
                        name="tagID"
                        rules={[{ required: true, message: '請輸入標籤 ID' }]}
                    >
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item
                        label="標籤名稱"
                        name="tagName"
                        rules={[{ required: true, message: '請輸入標籤名稱' }]}
                    >
                        <Input allowClear />
                    </Form.Item>

                    <Form.Item
                        label="標籤狀態"
                        name="tagStatus"
                    >
                        <Select placeholder="請選擇標籤狀態">
                            <Option value="Y">啟用</Option>
                            <Option value="N">停用</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="標籤備註"
                        name="tagNote"
                    >
                        <Input allowClear />
                    </Form.Item>
                    <Form.Item
                        label="標籤來源"
                        name="tagSource"
                    >
                        <Input allowClear />
                    </Form.Item>


                </Form>
            </Modal>
        )
    }



    const section = [
        {
            hasTitle: false,
            title: 'Search',
            children: <MemberTagSearchBar />,
        },
        {
            hasTitle: false,
            title: 'Search',
            children: <MemberTagDataTable />,
        },
        {
            hasTitle: false,
            title: 'Edit and Modal',
            children: <AssignNewTagModal />,
        },

    ];

    useEffect(() => {
        getTagsList();
    }, []);


    return (
        <>
            <PageHeader functionName={'toyota_member_tag_search'}></PageHeader>
            <PageBody section={section}></PageBody>
        </>
    );
}

export default MemberTagSearch;